







import Vue from 'vue';
import BaseFormElem from '../bases/BaseFormElem.vue';
import FileInput from '../FileInput/FileInput.vue';

export default Vue.extend({
  name: 'ImageFileInput',
  extends: BaseFormElem,
  components: { FileInput },
  props: {
    placeholder: {
      type: String,
      default: 'Upload your image',
    },
  },
});
